import {Component, HostListener, inject, OnInit, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {HeaderComponent} from "./layout/header/header.component";
import {FooterComponent} from "./layout/footer/footer.component";
import {ToTopButtonComponent} from "./components/to-top-button/to-top-button.component";
import {MessageComponent} from "./components/message/message.component";
import {AlertService} from "./services/api/alert.service";
import { GoogleAnalyticsService } from './services/helpers/gtag.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule, HeaderComponent, FooterComponent, ToTopButtonComponent, MessageComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'crypto_title';
  #translate = inject(TranslateService);
  #ga = inject(GoogleAnalyticsService);
  #alertService = inject(AlertService);
  loading = signal(true);
  isMobile = signal<boolean>(false);

  @HostListener('window:resize', ['$event']) onResize(event: any) {
    if (event.target.innerWidth <= 768 && this.isMobile()) return;
    if (event.target.innerWidth > 768 && !this.isMobile()) return;
    window.location.reload();
  }

  constructor() {
    const lang = localStorage.getItem('lang');
    const langList = ['en', 'ru', 'uz'];

    this.#translate.addLangs(langList);
    const langToUse = lang && langList.includes(lang) ? lang : 'ru';
    if (!lang) {
      localStorage.setItem('lang', 'ru');
    }
    this.#translate.setDefaultLang(langToUse);
    this.#translate.use(langToUse);
  }

  ngOnInit(): void {
    this.#ga.load();
  

    this.isMobile.set(window.innerWidth <= 768);
    setTimeout(() => {
      this.loading.set(false);
      this.showNotification().then(()=>{});
    }, 1000);
  }

  async showNotification(): Promise<void> {
    const dialog = await this.#alertService.getNotification('BASE_LOAD_DONE');
    if (!dialog) return;
  }
}
